import { api, hwApi } from "../../services";
import { $config } from "../../conf";
import store from "../../store";
import { $cookies } from "../../plugins/cookie";

export let hwAPI = {
  /**
   * 获取 报名信息
   * @returns {*}
   */
  getSignUpInfo() {
    return hwApi.request(
      `/events/attendees/getSignUpInfo?X-HW-APPKEY=${$config["X-HW-APPKEY"]}&X-HW-ID=${$config["X-HW-ID"]}`,
      {
        exhibitionId: $config.exhibitionId,
        userId: store.state["userInfo"]["token"].hwid,
      },
      {
        headers: {
          "x-hwid-token": store.state["userInfo"]["token"].access_token,
          "x-sino-token": store.state["userInfo"]["token"].smarketToken,
        },
      }
    );
  },
  /**
   * 获取 推荐信息
   * @returns {*}
   */
  getRecommendation({ recommendType }) {
    return hwApi.request(
      `/events/attendees/v1/ai/getRecommendation?X-HW-APPKEY=${$config["X-HW-APPKEY"]}&X-HW-ID=${$config["X-HW-ID"]}`,
      {
        exhibitionId: $config.exhibitionId,
        userId: store.state["userInfo"]["token"].hwid,
        recommendType,
        caller: 0,
      },
      {
        headers: {
          "x-hwid-token": store.state["userInfo"]["token"].access_token,
          "x-sino-token": store.state["userInfo"]["token"].smarketToken,
        },
      }
    );
  },
  /**
   * 核验票码
   * @returns {*}
   */
  verificationCode(option) {
    return hwApi.request(
      $config.verificationCodeUrl,
      {
        globalUserId: $cookies.globalUserId(),
        tenantId: $config.tenantId,
        seminarId: $config.seminarId,
        code: option.code,
        instanceId: $config.instanceId,
        sess: store.state.userInfo.token.smarketToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },

  /**
   * 获取门票二维码
   * @returns {*}
   */
  getQrcode() {
    return hwApi.request(
      $config.getQrcode,
      {
        sess: store.state.userInfo.token.smarketToken,
        seminarId: $config.seminarId,
        tenantId: $config.tenantId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },
  /**
   * 收藏/取消收藏 议程
   * @returns {*}
   */
  favoriteAgenda(option) {
    return hwApi.request(
      `/events/attendees/v1/user/favoriteAgenda?X-HW-APPKEY=${$config["X-HW-APPKEY"]}&X-HW-ID=${$config["X-HW-ID"]}`,
      {
        agendaId: option.agendaId,
        operation: option.operation, //操作类型：0：取消收藏1：添加收藏
        exhibitionSite: $config.seminarId, //展会站点
        objectType: option.objectType, //对象类型: agenda 议程；booth 展岛；
        exhibitionId: $config.exhibitionId,
        userId: store.state["userInfo"]["token"].hwid,
      },
      {
        headers: {
          "x-hwid-token": store.state["userInfo"]["token"].access_token,
          "x-sino-token": store.state["userInfo"]["token"].smarketToken,
        },
      }
    );
  },
  getMyAgendaList(option) {
    return hwApi.request(
      `/events/attendees/v1/user/agenda?X-HW-APPKEY=${$config["X-HW-APPKEY"]}&X-HW-ID=${$config["X-HW-ID"]}`,
      {
        exhibitionId: $config.exhibitionId,
        userId: store.state["userInfo"]["token"].hwid, //操作类型：0：取消收藏1：添加收藏
        exhibitionSite: $config.seminarId, //展会站点
        objectType: option.objectType, //对象类型: agenda 议程；booth 展岛；
      },
      {
        headers: {
          "x-hwid-token": store.state["userInfo"]["token"].access_token,
          "x-sino-token": store.state["userInfo"]["token"].smarketToken,
        },
      }
    );
  },
};
